/* Alternador de tema em tres estados.
 *
 * A capacidade ja existia no CSS do painel antigo — `[data-theme]` era honrado
 * — mas nada no JS chegava a escrever o atributo, entao o modo escuro so
 * acontecia por `prefers-color-scheme`. Aqui ele fica visivel, e "sistema"
 * continua sendo o padrao. */

import { useEffect, useState } from "react";

type Tema = "light" | "dark" | "system";

function apply(tema: Tema) {
  const root = document.documentElement;
  if (tema === "system") delete root.dataset.theme;
  else root.dataset.theme = tema;
  try {
    if (tema === "system") localStorage.removeItem("tema");
    else localStorage.setItem("tema", tema);
  } catch { /* modo privado: o tema simplesmente nao persiste */ }
}

export function ThemeToggle() {
  const [tema, setTema] = useState<Tema>(() => {
    try {
      const stored = localStorage.getItem("tema");
      return stored === "dark" || stored === "light" ? stored : "system";
    } catch { return "system"; }
  });

  useEffect(() => { apply(tema); }, [tema]);

  const next: Record<Tema, Tema> = { system: "light", light: "dark", dark: "system" };
  const icon: Record<Tema, string> = { system: "◐", light: "☀", dark: "☾" };
  const label: Record<Tema, string> = { system: "sistema", light: "claro", dark: "escuro" };

  return (
    <button className="btn" onClick={() => setTema(next[tema])}
            title={`Tema: ${label[tema]}. Clique para ${label[next[tema]]}.`}
            aria-label={`Tema ${label[tema]}, trocar para ${label[next[tema]]}`}>
      <span aria-hidden>{icon[tema]}</span>
    </button>
  );
}
